export const TIPI = [
  { value: 'CQP', label: 'Cessione Quinto Pensione' },
  { value: 'CQS', label: 'Cessione Quinto Stipendio' },
  { value: 'PP', label: 'Prestito Personale' },
  { value: 'Delega', label: 'Delega di Pagamento' },
];

export const STATI = [
  { value: 'da_lavorare', label: 'Da Lavorare', color: 'bg-slate-100 text-slate-600' },
  { value: 'in_istruttoria', label: 'In Istruttoria', color: 'bg-blue-100 text-blue-700' },
  { value: 'approvata', label: 'Approvata', color: 'bg-green-100 text-green-700' },
  { value: 'erogata', label: 'Erogata', color: 'bg-emerald-100 text-emerald-700' },
  { value: 'rifiutata', label: 'Rifiutata', color: 'bg-red-100 text-red-700' },
];

export const DOC_TYPES = [
  { value: 'carta_identita', label: "Carta d'Identita" },
  { value: 'passaporto', label: 'Passaporto' },
  { value: 'codice_fiscale', label: 'Codice Fiscale' },
  { value: 'busta_paga', label: 'Busta Paga' },
  { value: 'cedolino_pensione', label: 'Cedolino Pensione' },
  { value: 'cud', label: 'CUD' },
  { value: 'contratto', label: 'Contratto' },
  { value: 'altro', label: 'Altro' },
];

export const EMPTY_FORM = {
  tipo: 'CQP', nome_cliente: '', cognome_cliente: '', codice_fiscale: '', data_nascita: '',
  luogo_nascita: '', indirizzo_residenza: '', telefono: '', email: '', compagnia: '',
  importo_richiesto: '', importo_erogato: '', durata_mesi: '', tasso_tan: '', tasso_taeg: '',
  rata_mensile: '', assicurazione: false, assicurazione_dettagli: '', data_stipula: '',
  data_scadenza: '', data_erogazione: '', segnalato_da: '', provvigione_importo: '',
  provvigione_percentuale: '', assigned_to: '', note: '', stato: 'da_lavorare',
  numero_contratto: '', datore_lavoro: '',
};

export const getStatoStyle = (stato) => STATI.find(s => s.value === stato) || STATI[0];
